<template>
  <v-container
    class="wallets-view-container"
    fluid
  >
    <vault-wallets-table
      :wallets="wallets"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { VaultWalletsTable } from '@/components/vault';

export default {
  name: 'Wallets',
  components: {
    'vault-wallets-table': VaultWalletsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.vaultWalletsStore.loading,
      wallets: state => state.vaultWalletsStore.vaultWallets,
    }),
  },
  async mounted() {
    this.fetchWallets();
  },

  beforeDestroy() {
    this.resetVaultWalletStore();
  },

  methods: {
    ...mapActions(['getVaultWallets', 'resetVaultWalletStore']),
    fetchWallets() {
      const { search } = this.$route.query;
      clearTimeout(this.fetchTimeout);
      this.fetchTimeout = setTimeout(() => this.getVaultWallets(search), 1000);
    },
  },
};
</script>


<style lang="scss" scoped>
.wallets-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/vault/VaultWallets.vue